import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { FilesService } from '../../../core/services/files.service';
import { DriverService } from '../../../core/services/driver.service';
import { FleetService } from '../../../core/services/fleet.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SupplierService } from '../../../core/services/supplier.service';
import { SETTINGS } from '../../../core/config/common.settings';
import { AppUtils } from '../../../core/config/app.utils';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';

const ADD_EDIT_DRIVER_LICENCE_UPLOAD = 'ADD_EDIT_DRIVER_LICENCE_UPLOAD';
// const ADD_EDIT_DRIVER_PAYMENTS_UPLOAD = 'ADD_EDIT_DRIVER_PAYMENTS_UPLOAD';
const ADD_EDIT_DRIVER_OTHER_ATTACHMENTS_UPLOAD =
  'ADD_EDIT_DRIVER_OTHER_ATTACHMENTS_UPLOAD';

@Component({
  selector: 'app-add-driver-popup',
  templateUrl: './add-driver-popup.component.html',
  styleUrls: ['./add-driver-popup.component.scss'],
})
export class AddDriverPopupComponent implements OnInit {
  @Output() addEditDriverOnChange: EventEmitter<any> = new EventEmitter();
  @Input() isVisible = false;
  // @Input() canDriveOptions: any[] = [];
  driverForm: FormGroup | any;
  formErrors: any;
  fleetOptions: any[] = [];
  fleetSearchField: any;
  suppliers: any;
  innerLicenseDetailsErrors: any;
  isOutsourceDriver = false;
  isSrDriver = false;
  // isASupplier = false;
  // canDriveOptions = [
  //   { label: 'Light Vehicles', value: true },
  //   { label: 'Heavy Vehicles', value: true },
  // ];
  licenceAttachments: any[] = [];
  otherAttachments: any[] = [];
  licenceAttachmentUploading = false;
  otherAttachmentUploading = false;

  hasLicenseSubject = new BehaviorSubject(false);

  hasTourLicense = false;
  hasChauffeurGuideLicense = false;
  hasNationalGuideLicense = false;
  visibleAddSupplierPopup = false;

  constructor(
    private fb: FormBuilder,
    private filesService: FilesService,
    private driverService: DriverService,
    private fleetService: FleetService,
    private messages: NzMessageService,
    private supplierService: SupplierService,
  ) {
    this.formErrors = {
      driverSegment: {},
      supplier: {},
      isRegistered: {},
      contractOrPermanent: {},
      fullName: {},
      mobileNumber: {},
      email: {},
      nicNo: {},
    };
    this.innerLicenseDetailsErrors = {
      licenseDetails: {
        drivingLicenseExpiryDate: {},
      },
    };
  }

  ngOnInit(): void {
    this.driverService.initAddDriverPopupForm.subscribe((val) => {
      if (val) {
        this.initDriverForm();
      }
    });
    // this.initDriverForm();
    this.getSuppliers();
    this.filesService.fileUploadingSubject.subscribe((res: any) => {
      if (res.type === ADD_EDIT_DRIVER_LICENCE_UPLOAD) {
        this.licenceAttachmentUploading = res.loading;
      }
      if (res.type === ADD_EDIT_DRIVER_OTHER_ATTACHMENTS_UPLOAD) {
        this.otherAttachmentUploading = res.loading;
      }
    });

    this.supplierService.suppliersOnChange.subscribe((res: any[]) => {
      this.suppliers = res;
    });
  }

  getSuppliers(): void {
    this.supplierService.getAllSuppliers().then((res) => {});
  }

  navigateToAddSupplier(): void {
    this.visibleAddSupplierPopup = true;
  }

  // Language Skills form loop array stuff
  createLanguage(): FormGroup {
    return this.fb.group({
      language: [null],
      level: [null],
    });
  }

  get languageSkills(): FormArray {
    return this.driverForm.get('languageSkills');
  }

  addItems() {
    this.languageSkills.push(this.createLanguage());
  }

  removeItem(event: Event, i: any): void {
    this.languageSkills.removeAt(i);
  }

  initDriverForm(): void {
    this.driverForm = this.fb.group({
      driverSegment: [null, [Validators.required]],
      supplier: [null, []],
      contractOrPermanent: [null, []],
      isRegistered: [null],
      fullName: [
        null,
        [
          Validators.compose([
            Validators.required,
            Validators.pattern(SETTINGS.REGEX.LETTERS.EXP),
          ]),
        ],
      ],
      mobileNumber: [
        null,
        [
          Validators.compose([
            Validators.required,
            Validators.pattern(SETTINGS.REGEX.PHONE.EXP),
          ]),
        ],
      ],
      nicNo: [null, []],
      // assignsVehicles: [null, []],
      email: [null, [Validators.email]],
      canDrive: [
        [
          { label: 'Light Vehicles', value: true },
          { label: 'Heavy Vehicles', value: true },
        ],
        [],
      ],
      languageSkills: this.fb.array([this.createLanguage()]),
      licenseDetails: this.fb.group({
        drivingLicenseExpiryDate: [null, []],
        hasTourDriverLicense: [null],
        tourDriverLicenseExpiryDate: [null],
        hasChauffeurGuideLicense: [null],
        chauffeurGuideLicenseExpiryDate: [null],
        hasNationalGuideLicense: [null],
        nationalGuideLicenseExpiryDate: [null],
        attachments: [null],
      }),
      notes: [null],
    });

    this.driverForm.valueChanges.subscribe((values: any) => {
      if (values.driverSegment) {
        switch (values.driverSegment) {
          case 'OUTSOURCE_DRIVER':
            this.isOutsourceDriver = true;
            this.isSrDriver = false;
            this.driverForm.get('canDrive').clearValidators();
            this.driverForm.get('contractOrPermanent').clearValidators();
            this.driverForm
              .get('licenseDetails')
              .controls.drivingLicenseExpiryDate.clearValidators();
            this.driverForm.get('nicNo').clearValidators();
            this.driverForm.get('supplier').addValidators(Validators.required);
            break;

          case 'SR_DRIVER':
            this.isOutsourceDriver = false;
            this.isSrDriver = true;
            this.driverForm
              .get('contractOrPermanent')
              .addValidators(Validators.required);
            this.driverForm.get('nicNo').addValidators(Validators.required);
            this.driverForm.get('canDrive').addValidators(Validators.required);
            this.driverForm
              .get('licenseDetails')
              .controls.drivingLicenseExpiryDate.addValidators(
                Validators.required,
              );
            this.driverForm.get('supplier').clearValidators();
            break;
        }
      }

      this.hasTourLicense = !!values.licenseDetails.hasTourDriverLicense;
      this.hasChauffeurGuideLicense =
        !!values.licenseDetails.hasChauffeurGuideLicense;
      this.hasNationalGuideLicense =
        !!values.licenseDetails.hasNationalGuideLicense;

      this.formErrors = AppUtils.getFormErrors(
        this.driverForm,
        this.formErrors,
      );

      this.innerLicenseDetailsErrors.licenseDetails = AppUtils.getFormErrors(
        this.driverForm.get('licenseDetails'),
        this.innerLicenseDetailsErrors.licenseDetails,
      );
    });
  }

  licenceUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_DRIVER_LICENCE_UPLOAD)
      .subscribe((res) => {
        const data = res as any;
        this.licenceAttachments.push({ name: data.name, url: data.url });
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_DRIVER_LICENCE_UPLOAD,
          loading: false,
        });
        this.messages.create('success', `Attachment has been uploaded!`);
      });

  otherAttachmentOnUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_DRIVER_OTHER_ATTACHMENTS_UPLOAD)
      .subscribe((res) => {
        const data = res as any;
        this.otherAttachments.push({ name: data.name, url: data.url });
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_DRIVER_OTHER_ATTACHMENTS_UPLOAD,
          loading: false,
        });
        this.messages.create('success', `Attachment has been uploaded!`);
      });

  removeAttachment(index: number, type: string): void {
    switch (type) {
      case 'licences':
        this.licenceAttachments.splice(index, 1);
        this.messages.create('success', `Attachment has been deleted!`);
        break;
      case 'other':
        this.otherAttachments.splice(index, 1);
        this.messages.create('success', `Attachment has been deleted!`);
        break;
    }
  }

  removeVehiclePhoto(): void {
    console.log('CLICKED');
  }

  handleCancel(): void {
    this.isVisible = false;
    this.addEditDriverOnChange.emit({ name: 'isVisible', value: false });
    this.driverForm.reset();
    this.driverService.initAddDriverPopupForm.next(false);
  }

  cancel(): void {}

  confirm(): void {
    this.isVisible = false;
    this.addEditDriverOnChange.emit({ name: 'isVisible', value: false });
    this.driverForm.reset();
    this.driverService.initAddDriverPopupForm.next(false);
  }

  onSubmit(): void {
    const canDrive: any[] = [];
    let payload: any = {};
    try {
      this.driverForm.patchValue({
        licenseDetails: {
          attachments: this.licenceAttachments,
        },
      });
      const formData = this.driverForm.getRawValue();
      formData.canDrive.forEach((op: any) => {
        canDrive.push({ label: op.label, checked: op.checked });
      });
      formData.canDrive = canDrive;
      payload = {
        ...formData,
        attachments:
          this.otherAttachments?.length > 0 ? this.otherAttachments : null,
      };
      this.driverService.createDriver(payload).subscribe(
        (res) => {
          // this.messages.create('success', `New driver has been added!`);
          this.isVisible = false;
          this.addEditDriverOnChange.emit({
            name: 'created',
            value: formData.driverSegment,
          });
        },
        (e: any) => {
          if (e?.error?.errors?.email) {
            this.messages.create('error', `Email is already existing!`);
          }
        },
      );
    } catch (e: any) {}
    // if (this.suppliersForm.valid) {
    //   this.supplierService
    //     .createSupplier({
    //       ...this.suppliersForm.value,
    //       paymentAttachment: this.paymentFiles,
    //     })
    //     .then(() => {
    //       this.suppliersForm.reset();
    //       this.paymentFiles = [];
    //       this.isVisible = false;
    //       this.addEditSupplierOnChange.emit({
    //         name: 'created',
    //         value: false,
    //       });
    //     });
    // } else {
    //   this.markFormGroupAsTouched(this.suppliersForm);
    // }
  }

  onGetAddSupplierChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleAddSupplierPopup = false;
        break;
      case 'created':
        this.messages.create('success', 'New Supplier has been added!');
        this.getSuppliers();
        this.visibleAddSupplierPopup = false;
        break;
    }
  }

  handleOk(): void {}
}
